export default __webpack_public_path__ + "static/media/logo_makansafe.c32a1a1d.png";